import { ChangeDetectorRef, Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ResponseCode } from '@lsq-frontend/angular-shared/api-service';
import { AlertService } from '@lsq-frontend/angular-shared/features/alert-service';
import { ModalServiceToken } from '@lsq-frontend/common-ui';
import {
    DocumentService,
    FieldData,
    FieldOption,
    FieldSchema,
    SchemaService,
    V1DocumentRequestBody
} from '@lsq-frontend/remote-services/ar-app';
import { LsqValidators } from '@lsq-frontend/common-ui';
import { Modal, ModalService } from '@lsq-frontend/common-ui';
import { BehaviorSubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SchemaTypes } from '../../constants/schema-types.constants';
import { documentListRequestForm } from '../../forms/document-list-forms';
import { DrApplicationService } from '../../service/dr-application-service';
import { AddDocumentListModal } from './add-document-list-modal/add-document-list-modal.component';

@Component({
    selector: 'dr-add-document-list-field',
    templateUrl: './dr-add-document-list-field.component.html',
    styleUrls: ['./dr-add-document-list-field.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AddDocumentListField {
    public formGroup: FormGroup;
    public fieldSchema: FieldSchema;
    public field: FieldData;
    @Input() prospectDataId: string;
    @Input() schemaType: string;
    @Input() adminMode: Boolean;
    @Input() label: string;

    constructor(
        @Inject(ModalServiceToken) private _modalService: ModalService,
        private _documentService: DocumentService,
        private _alertService: AlertService,
        private _arService: DrApplicationService,
        private _schemaService: SchemaService
    ) {}

    public async handleRequestDocument() {
        const requestDocumentFormGroup: FormGroup = documentListRequestForm();

        const getProspectSchemaResponse = await this._schemaService.getProspectSchema(
            null,
            false,
            false,
            SchemaTypes.DocumentList
        );
        var data = {
            formGroup: requestDocumentFormGroup,
            schema: getProspectSchemaResponse,
            schemaType: this.schemaType
        };

        const isSubmittingSubject = new BehaviorSubject<boolean>(false);

        const okButtonIsDisabled$ = requestDocumentFormGroup.valueChanges.pipe(
            map((_) => !requestDocumentFormGroup.valid),
            startWith(!requestDocumentFormGroup.valid)
        );
        this._modalService.showModal(
            new Modal({
                title: this.label,
                bodyComponent: AddDocumentListModal,
                showCloseButton: true,
                showFooter: true,
                showOkButton: true,
                okButtonText: 'Request',
                okButtonIsDisabled$,
                okButtonSize: 'block',
                showCancelButton: true,
                clickOutsideToClose: false,
                data: data,
                isSubmitting$: isSubmittingSubject,
                onCancelClick: () => this._modalService.closeModal(),
                onOkClick: async () => {
                    if (requestDocumentFormGroup.valid) {
                        isSubmittingSubject.next(true);
                        await this.requestDocument(requestDocumentFormGroup);
                        isSubmittingSubject.next(false);
                    }
                }
            })
        );
    }

    public async requestDocument(formGroup: FormGroup): Promise<void> {
        const fieldSchemas = formGroup.value.documentListSelect.stageSchemas[0].fieldSchemas;

        for (const fieldSchema of fieldSchemas) {
            fieldSchema.fieldOption.scheduleRequest = formGroup.value.scheduleRequest || false;
            fieldSchema.fieldOption.startDate = formGroup.value.startDate || null;
            fieldSchema.fieldOption.repeatEvery = formGroup.value.repeatEvery;
            fieldSchema.fieldOption.repeats = formGroup.value.repeats;
        }
        const documents: V1DocumentRequestBody = {
            documents: [...fieldSchemas]
        };
        const stageSchemaDocumentId = this._arService.getDocumentsStageID();
        const postDocumentRequest = this._documentService.addDocumentRequest(
            documents,
            this.prospectDataId,
            stageSchemaDocumentId
        );
        try {
            formGroup.setErrors({});
            const schemaData = await postDocumentRequest.toPromise();
            this._arService.setProspectSchema(schemaData);
            this._modalService.closeModal();
            this._alertService.success('Success');
        } catch (err) {
            if (err.code === ResponseCode.Conflict) {
                this._modalService.closeModal();
                this._alertService.info(err.message);
                this._arService.reloadData();
            } else {
                formGroup.setErrors({ err: err.message });
            }
        }
    }
}
